import { formatarData, formatarMoeda } from "../../../utils/solicitacoes/formatters";

export function Info({ label, valor }) {
    return (
        <div className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <span className="block text-foreground font-medium break-words">{valor || "-"}</span>
        </div>
    );
}

export function Tabela({ titulo, cabecalho, linhas }) {
    return (
        <div>
            <h4 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-1">{titulo}</h4>
            {linhas.length === 0 ? (
                <p className="text-xs text-muted-foreground">Nenhum registro.</p>
            ) : (
                <div className="overflow-x-auto border border-border rounded-md">
                    <table className="w-full text-xs">
                        <thead className="bg-muted">
                            <tr className="text-left text-[10px] uppercase tracking-wide text-muted-foreground">
                                {cabecalho.map(c => <th key={c} className="px-2 py-1.5 font-semibold">{c}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {linhas.map((linha, i) => (
                                <tr key={i} className="border-t border-border">
                                    {linha.map((celula, j) => <td key={j} className="px-2 py-1.5 whitespace-nowrap">{celula}</td>)}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

// Situação de pagamento a partir das parcelas (VCP.QUITADO) dos lançamentos, ignorando parcelas canceladas.
// Retorna "PAGO", "EM_ABERTO", "PARCIAL:x/y" ou null quando não há parcelas.
export function situacaoPagamento(lancamentos = []) {
    const parcelas = lancamentos.flatMap(l => l.parcelas || []).filter(p => !p.dataCancelamento);
    if (parcelas.length === 0) return null;
    const pagas = parcelas.filter(p => p.quitado).length;
    if (pagas === parcelas.length) return "PAGO";
    return pagas === 0 ? "EM_ABERTO" : `PARCIAL:${pagas}/${parcelas.length}`;
}

function quitado(valor) {
    if (valor == null) return "-";
    return valor ? "Sim" : "Não";
}

/** Lançamento de contas a pagar do Fortes (CPG): cabeçalho, parcelas e rateio. */
export default function LancamentoFortesCard({ lancamento: l }) {
    return (
        <div className="border border-border rounded-lg p-3 flex flex-col gap-3">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                <Info label="Código Fortes" valor={l.codigo} />
                <Info label="Documento" valor={l.numeroDocumento} />
                <Info label="Valor" valor={formatarMoeda(l.valor)} />
                <Info label="Filial (Fortes)" valor={l.filialNome} />
                <Info label="Emissão" valor={formatarData(l.dataEmissao)} />
                <Info label="Entrada" valor={formatarData(l.dataEntrada)} />
                <Info label="Tipo de documento" valor={l.tipoDocumento || l.especie} />
                <Info label="Conta" valor={l.contaNome} />
                <Info label="Histórico" valor={l.historico} />
                <div className="col-span-2 md:col-span-3"><Info label="Observação" valor={l.observacao} /></div>
            </div>

            <Tabela
                titulo="Parcelas"
                cabecalho={["Seq.", "Vencimento", "Título", "Valor", "Desconto", "Quitado", "Cancelada"]}
                linhas={(l.parcelas || []).map(p => [
                    p.sequencial ?? "-", formatarData(p.data), p.numeroTitulo || "-", formatarMoeda(p.valor),
                    formatarMoeda(p.desconto), quitado(p.quitado),
                    p.dataCancelamento ? `${formatarData(p.dataCancelamento)}${p.motivoCancelamento ? ` — ${p.motivoCancelamento}` : ""}` : "-",
                ])}
            />
            <Tabela
                titulo="Rateio"
                cabecalho={["Filial", "Centro de Custo", "Conta", "Valor", "Conta Contábil", "Nº Solicitação", "Obs."]}
                linhas={(l.rateio || []).map(r => [
                    r.filialNome || r.filialCodigo || "-",
                    [r.centroCustoCodigo, r.centroCustoNome].filter(Boolean).join(" · ") || "-",
                    [r.contaCodigo, r.contaNome].filter(Boolean).join(" · ") || "-",
                    formatarMoeda(r.valor), r.contaContabil || "-", r.numeroSolicitacao || "-", r.observacao || "-",
                ])}
            />
        </div>
    );
}
